// Paket 18 (RUE): Regeln der Antwortbewertung, ohne React, damit sie ohne Browser prüfbar sind.
export type Verdict = 'UP' | 'DOWN';
export type RatingCategory = 'WRONG_SOURCE' | 'OUTDATED' | 'MISSED_QUESTION' | 'INCOMPLETE' | 'OTHER';
export const RATING_CATEGORIES: ReadonlyArray<readonly [RatingCategory, string]> = [
  ['WRONG_SOURCE', 'Falsche Quelle'], ['OUTDATED', 'Veraltet'], ['MISSED_QUESTION', 'Frage nicht getroffen'],
  ['INCOMPLETE', 'Unvollständig'], ['OTHER', 'Sonstiges'],
];
export const COMMENT_MAX = 500;
// Der Produktname kommt aus der Marke der Plattform (RSM-21, MK-1d), nie aus einer Organisation.
export const ratingNotice = (displayName: string) =>
  `Ihre Bewertung hilft, die Antworten zu verbessern. Ihre Firma sieht sie nicht; ${displayName} wertet sie nur zusammengefasst und ohne Namen aus. Ein Kommentar wird verschlüsselt gespeichert, nur Ihnen angezeigt und nach 90 Tagen gelöscht.`;
export function commentProblem(text: string): string | null {
  return text.trim().length > COMMENT_MAX ? 'Höchstens 500 Zeichen.' : null;
}
export function ratingPayload(verdict: Verdict, category: RatingCategory | null, comment: string) {
  if (verdict === 'UP') return { verdict, category: null, comment: null };
  return { verdict, category, comment: comment.trim() || null };
}
